import React from "react";

export const MultiSelectOptionMarkup = ({ children }) => (
  <div className="row">
    <div className="col-1"><span className="checkbox"></span></div>
    <div className="col-9"><span> {children}</span></div>
  </div>
);
